import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import { store } from './store';
import vuetify from './plugins/vuetify';
import baseapi from './plugins/baseapi';
import axios from 'axios';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';

Vue.use(Viewer);
Vue.use(baseapi);
// prod
// var firebaseConfig = {
 // apiKey: "AIzaSyC9Skj_GGUBx4wYG-f4aZAN79_NxljJqho",
          // authDomain: "klik-lelang-indonesia.firebaseapp.com",
          // projectId: "klik-lelang-indonesia",
          // storageBucket: "klik-lelang-indonesia.firebasestorage.app",
          // messagingSenderId: "960050750023",
          // appId: "1:960050750023:web:acbdb23a85ceedd0d48762",
          // measurementId: "G-4HBF9DTGNC",
// };

////dev
var firebaseConfig = {
  apiKey: 'AIzaSyAa52B45-cy3GWb2LIH3pUzqh9igcTHUrs',
  authDomain: 'klik-lelang-indonesia-dev.firebaseapp.com',
  databaseURL: 'https://klik-lelang-indonesia-dev-default-rtdb.firebaseio.com',
  projectId: 'klik-lelang-indonesia-dev',
  storageBucket: 'klik-lelang-indonesia-dev.firebasestorage.app',
  messagingSenderId: '982173070536',
  appId: '1:982173070536:web:33cf72ea5f05064885e1fd',
  measurementId: 'G-45PBLS42XZ'
};



// // Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();

Vue.config.productionTip = false;

const defaultOptions = {
  // PROD
  // baseURL: 'https://api.kliklelang.id/api/',
  //DEV
  baseURL: 'https://api.devlmu.com/kliklelang/',

  timeout: 0,
  headers: {
    // 'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
};
let instance = axios.create(defaultOptions);
instance.interceptors.request.use(function(config) {
  const token = localStorage.getItem('token');

  if (token) config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
});

Vue.prototype.$req = instance;
//PROD
// Vue.prototype.$url_img = `https://api.kliklelang.id/service/image/`;
//DEV
Vue.prototype.$url_img = `https://api.devlmu.com/kliklelang/images/service/image/`;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
